import { render } from "./studentcertification.vue?vue&type=template&id=8d109ff6&scoped=true"
import script from "./studentcertification.vue?vue&type=script&lang=js"
export * from "./studentcertification.vue?vue&type=script&lang=js"

import "./studentcertification.vue?vue&type=style&index=0&id=8d109ff6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d109ff6"]])

export default __exports__